module.exports = __webpack_public_path__ + "static/media/Margaery Tyrell 3.9ad6fc8e.jpg";